var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_204",
    "data-name": "Group 204",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 314,
    height: 56.255,
    viewBox: "0 0 314 56.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 314,
    height: 56.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 314.001,
    height: 56.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 21.585,
    height: 19.412,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M842.106,87.778,831.024,68.366h-10.5V87.778Z",
    transform: "translate(-820.522 -68.366)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M233.95,20.341v-.107a19.339,19.339,0,0,1,38.673-.105v.105a19.339,19.339,0,0,1-38.673.107m31.858,0v-.107c0-7.185-5.231-13.155-12.575-13.155s-12.468,5.865-12.468,13.05v.105c0,7.186,5.23,13.1,12.574,13.1s12.468-5.811,12.468-13",
    transform: "translate(-170.181 -0.807)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M132.309,9.192H120V3.358h31.5V9.192H139.2V40.483h-6.895Z",
    transform: "translate(-87.294 -2.443)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M421.6,3.358V40.483h-5.675L395.45,15.344V40.483h-6.842V3.358h5.675L414.755,28.5V3.358Z",
    transform: "translate(-282.683 -2.443)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M562.752,34.7v5.781h-26.2V3.359h26.2v5.78h-19.3v9.653h19.23v5.675h-19.23V34.7Z",
    transform: "translate(-390.302 -2.443)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M1080.772,34.7v5.781h-26.2V3.359h26.2v5.78h-19.3v9.653h19.23v5.675h-19.23V34.7Z",
    transform: "translate(-767.122 -2.443)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M676.861,20.08h6.524v14.8a20.729,20.729,0,0,1-6.683,3.5,25.641,25.641,0,0,1-7.849,1.22,21.163,21.163,0,0,1-10.236-2.466,18.307,18.307,0,0,1-7.16-6.815,18.755,18.755,0,0,1-2.6-9.812,18.756,18.756,0,0,1,2.6-9.811,18.276,18.276,0,0,1,7.186-6.816,21.44,21.44,0,0,1,10.315-2.466,22.536,22.536,0,0,1,8.486,1.538,16.663,16.663,0,0,1,6.417,4.508L679.513,11.7a13.95,13.95,0,0,0-10.236-4.243A14.468,14.468,0,0,0,662.3,9.1a11.979,11.979,0,0,0-4.773,4.614,13.269,13.269,0,0,0-1.724,6.788,13.057,13.057,0,0,0,1.724,6.682,12.339,12.339,0,0,0,4.773,4.668,13.983,13.983,0,0,0,6.921,1.7,14.94,14.94,0,0,0,7.637-1.909Z",
    transform: "translate(-471.995 -1.026)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M937.516,9.192h-12.3V3.358h31.5V9.192h-12.3V40.483h-6.894Z",
    transform: "translate(-673.02 -2.443)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M831.76,38.047h-6.354V16.926a10.573,10.573,0,1,0-21.146,0V38.047h-6.354V16.926a16.926,16.926,0,0,1,33.853,0Z",
    transform: "translate(-580.416)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(223.655 18.635)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 21.806,
    height: 19.898,
    transform: "translate(-0.142 -0.268)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABJCAYAAACqyKH+AAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAUKADAAQAAAABAAAASQAAAAB/2JuGAAABNElEQVR4Ae3bu3XDMBQFQdGWP11Y7r9I2q8FLDKM8kUwvKCOAl33fT981gXe1lPlCFw/r98LxbrA8z+1wnW/B8CAN+kAvsczjs4BxscPEGAUiLkFbgAcRJ9FgcEDuIg3GcCABzDiAdwE+LHhnGOPmHcgwPD4fYkEvEktEGAUiLkFAowCMZ8FfsYzjs5d4fj4AW4AdIUDondgwJvUFd4A6AoHRFc44E0KEGAUiPks8CuecXTuCsfHD3ADoCscEC0w4E3qS2QDoF8iAdECA96kAAFGgZhbIMAoEHMLBBgFYm6BGwC/4xlH5xYYHz/ADYD+LxwQ/Vc44E0KEGAUiLkFAowCMbdAgFEg5hYIMArE3AIBRoGYWyDAKBBzCwQYBWJugQCjQMwtEGAUiLkFAowCMbfACPgHJgEFTUDi84cAAAAASUVORK5CYII="
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M7.516,27.422c.964,3.952,3.957,5.839,8.946,5.839,5.132,0,7.259-2.031,7.259-5,0-3.243-1.928-4.81-9.114-6.389C4.307,19.6,1.439,16.177,1.439,11.125,1.439,5.019,6.329.617,15.538.617c10.162,0,14.253,5.2,14.81,10.411H22.832c-.516-2.618-2.16-5.163-7.506-5.163-3.944,0-6.255,1.573-6.255,4.5,0,2.874,1.875,4.026,8.471,5.472C29,18.377,31.352,22.405,31.352,27.448c0,6.469-5.228,11.1-15.447,11.1-10.04,0-15-4.769-15.905-11.131Z",
    transform: "translate(0 -0.449)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M10.872,182.623H6.849l-.793,1.863H4.515l3.621-8.047H9.608l3.633,8.047H11.677Zm-.494-1.172-1.517-3.518-1.506,3.518Z",
    transform: "translate(-3.284 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M82.357,176.783a2.652,2.652,0,0,1,1.19.989,3.021,3.021,0,0,1,0,3.052,2.636,2.636,0,0,1-1.19.994,4.458,4.458,0,0,1-1.822.345H78.719v2.322H77.224v-8.047h3.311a4.458,4.458,0,0,1,1.822.345m-.408,3.7a1.639,1.639,0,0,0,0-2.368,2.3,2.3,0,0,0-1.483-.414H78.719v3.2h1.747a2.3,2.3,0,0,0,1.483-.414",
    transform: "translate(-56.175 -128.345)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M125.339,184.486l-1.644-2.357a3,3,0,0,1-.31.011h-1.816v2.345h-1.495v-8.047h3.311a4.454,4.454,0,0,1,1.822.345,2.649,2.649,0,0,1,1.19.989,2.766,2.766,0,0,1,.414,1.529,2.727,2.727,0,0,1-.442,1.564,2.635,2.635,0,0,1-1.27.977l1.851,2.644Zm-.54-6.369a2.3,2.3,0,0,0-1.483-.414h-1.747v3.207h1.747a2.272,2.272,0,0,0,1.483-.42,1.458,1.458,0,0,0,.506-1.19,1.442,1.442,0,0,0-.506-1.184",
    transform: "translate(-87.345 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M163.564,183.759a3.954,3.954,0,0,1-1.552-1.483,4.274,4.274,0,0,1,0-4.242,3.955,3.955,0,0,1,1.552-1.483,4.873,4.873,0,0,1,4.437,0,3.973,3.973,0,0,1,1.552,1.477,4.3,4.3,0,0,1,0,4.254A3.968,3.968,0,0,1,168,183.759a4.869,4.869,0,0,1-4.437,0m3.667-1.138a2.621,2.621,0,0,0,1.012-1.012,3.059,3.059,0,0,0,0-2.908,2.62,2.62,0,0,0-1.012-1.012,3.077,3.077,0,0,0-2.9,0,2.616,2.616,0,0,0-1.012,1.012,3.056,3.056,0,0,0,0,2.908,2.617,2.617,0,0,0,1.012,1.012,3.077,3.077,0,0,0,2.9,0",
    transform: "translate(-117.442 -128.039)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M211.721,176.439h3.518a5.048,5.048,0,0,1,2.287.5,3.7,3.7,0,0,1,1.552,1.414,4.309,4.309,0,0,1,0,4.219,3.7,3.7,0,0,1-1.552,1.414,5.048,5.048,0,0,1-2.287.5h-3.518Zm3.449,6.783a3.416,3.416,0,0,0,1.558-.339,2.423,2.423,0,0,0,1.035-.966,3.1,3.1,0,0,0,0-2.908,2.427,2.427,0,0,0-1.035-.966,3.416,3.416,0,0,0-1.558-.339h-1.954v5.518Z",
    transform: "translate(-154.011 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M259.889,183.664a3.645,3.645,0,0,1-.931-2.684v-4.541h1.495v4.483q0,2.369,2.046,2.368t2.034-2.368v-4.483H266v4.541a3.659,3.659,0,0,1-.925,2.684,4.063,4.063,0,0,1-5.19,0",
    transform: "translate(-188.372 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M305.128,183.76a3.941,3.941,0,0,1-1.541-1.477,4.316,4.316,0,0,1,.006-4.254,3.98,3.98,0,0,1,1.546-1.477,4.533,4.533,0,0,1,2.2-.535,4.6,4.6,0,0,1,1.8.345,3.679,3.679,0,0,1,1.379,1l-.965.908a2.817,2.817,0,0,0-2.15-.943,3.016,3.016,0,0,0-1.483.362A2.608,2.608,0,0,0,304.9,178.7a3.081,3.081,0,0,0,0,2.92,2.606,2.606,0,0,0,1.023,1.006,3.015,3.015,0,0,0,1.483.362,2.8,2.8,0,0,0,2.15-.954l.965.92a3.673,3.673,0,0,1-1.385,1,4.639,4.639,0,0,1-1.811.345,4.533,4.533,0,0,1-2.2-.535",
    transform: "translate(-220.431 -128.039)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M354.487,183.233v1.253h-6.035v-8.047h5.875v1.253h-4.38v2.093h3.886v1.23h-3.886v2.219Z",
    transform: "translate(-253.472 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M394.627,184.486l-1.644-2.357a3,3,0,0,1-.31.011h-1.816v2.345h-1.495v-8.047h3.311a4.454,4.454,0,0,1,1.822.345,2.649,2.649,0,0,1,1.19.989,2.766,2.766,0,0,1,.414,1.529,2.728,2.728,0,0,1-.442,1.564,2.636,2.636,0,0,1-1.271.977l1.851,2.644Zm-.54-6.369a2.3,2.3,0,0,0-1.483-.414h-1.747v3.207H392.6a2.272,2.272,0,0,0,1.483-.42,1.458,1.458,0,0,0,.506-1.19,1.442,1.442,0,0,0-.506-1.184",
    transform: "translate(-283.231 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M431.731,184.03a3.753,3.753,0,0,1-1.374-.7l.517-1.161a4.067,4.067,0,0,0,1.213.638,4.408,4.408,0,0,0,1.443.247,2.492,2.492,0,0,0,1.339-.287.871.871,0,0,0,.442-.759.734.734,0,0,0-.247-.569,1.736,1.736,0,0,0-.626-.351q-.379-.126-1.035-.287a12,12,0,0,1-1.489-.437,2.451,2.451,0,0,1-.977-.684,1.844,1.844,0,0,1-.408-1.259,2.146,2.146,0,0,1,.362-1.213,2.453,2.453,0,0,1,1.092-.868,4.432,4.432,0,0,1,1.788-.322,5.777,5.777,0,0,1,1.448.184,4.006,4.006,0,0,1,1.23.529l-.471,1.161a4.657,4.657,0,0,0-1.1-.471,4.139,4.139,0,0,0-1.115-.161,2.33,2.33,0,0,0-1.317.3.923.923,0,0,0-.431.793.717.717,0,0,0,.247.563,1.787,1.787,0,0,0,.627.345q.379.127,1.035.288a10.914,10.914,0,0,1,1.471.431,2.523,2.523,0,0,1,.983.684,1.8,1.8,0,0,1,.408,1.241,2.119,2.119,0,0,1-.362,1.207,2.463,2.463,0,0,1-1.1.862,4.468,4.468,0,0,1-1.793.322,6.137,6.137,0,0,1-1.8-.264",
    transform: "translate(-313.052 -128.039)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M503.469,176.439v8.047h-1.23l-4.437-5.449v5.449h-1.483v-8.047h1.23l4.437,5.449v-5.449Z",
    transform: "translate(-361.033 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M545.315,182.623h-4.023l-.793,1.863h-1.541l3.621-8.047h1.471l3.633,8.047H546.12Zm-.495-1.172-1.517-3.518-1.506,3.518Z",
    transform: "translate(-392.051 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M584.77,177.7H582.1v-1.264h6.829V177.7h-2.667v6.783H584.77Z",
    transform: "translate(-423.436 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 1.495,
    height: 8.047,
    transform: "translate(170.072 48.093)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M650.053,183.759a3.956,3.956,0,0,1-1.552-1.483,4.275,4.275,0,0,1,0-4.242,3.957,3.957,0,0,1,1.552-1.483,4.874,4.874,0,0,1,4.437,0,3.975,3.975,0,0,1,1.552,1.477,4.3,4.3,0,0,1,0,4.254,3.971,3.971,0,0,1-1.552,1.477,4.869,4.869,0,0,1-4.437,0m3.667-1.138a2.619,2.619,0,0,0,1.011-1.012,3.057,3.057,0,0,0,0-2.908,2.619,2.619,0,0,0-1.011-1.012,3.077,3.077,0,0,0-2.9,0,2.618,2.618,0,0,0-1.012,1.012,3.058,3.058,0,0,0,0,2.908,2.619,2.619,0,0,0,1.012,1.012,3.077,3.077,0,0,0,2.9,0",
    transform: "translate(-471.325 -128.039)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M705.362,176.439v8.047h-1.23l-4.437-5.449v5.449h-1.483v-8.047h1.23l4.437,5.449v-5.449Z",
    transform: "translate(-507.895 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M747.208,182.623h-4.023l-.793,1.863h-1.541l3.621-8.047h1.471l3.633,8.047h-1.564Zm-.494-1.172-1.517-3.518-1.506,3.518Z",
    transform: "translate(-538.912 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M789.267,176.439h1.495v6.783h4.208v1.265h-5.7Z",
    transform: "translate(-574.132 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M851.465,183.76a3.941,3.941,0,0,1-1.541-1.477,4.315,4.315,0,0,1,.006-4.254,3.98,3.98,0,0,1,1.546-1.477,4.534,4.534,0,0,1,2.2-.535,4.6,4.6,0,0,1,1.8.345,3.679,3.679,0,0,1,1.38,1l-.965.908a2.817,2.817,0,0,0-2.15-.943,3.016,3.016,0,0,0-1.483.362,2.607,2.607,0,0,0-1.023,1.006,3.08,3.08,0,0,0,0,2.92,2.605,2.605,0,0,0,1.023,1.006,3.015,3.015,0,0,0,1.483.362,2.8,2.8,0,0,0,2.15-.954l.965.92a3.673,3.673,0,0,1-1.385,1,4.639,4.639,0,0,1-1.811.345,4.533,4.533,0,0,1-2.2-.535",
    transform: "translate(-617.849 -128.039)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M894.163,183.759a3.956,3.956,0,0,1-1.552-1.483,4.274,4.274,0,0,1,0-4.242,3.956,3.956,0,0,1,1.552-1.483,4.874,4.874,0,0,1,4.437,0,3.975,3.975,0,0,1,1.552,1.477,4.3,4.3,0,0,1,0,4.254,3.97,3.97,0,0,1-1.552,1.477,4.869,4.869,0,0,1-4.437,0m3.667-1.138a2.622,2.622,0,0,0,1.012-1.012,3.059,3.059,0,0,0,0-2.908,2.621,2.621,0,0,0-1.012-1.012,3.076,3.076,0,0,0-2.9,0,2.617,2.617,0,0,0-1.012,1.012,3.057,3.057,0,0,0,0,2.908,2.618,2.618,0,0,0,1.012,1.012,3.076,3.076,0,0,0,2.9,0",
    transform: "translate(-648.897 -128.039)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M949.713,184.485l-.011-5.334-2.644,4.414h-.666l-2.644-4.345v5.265h-1.425v-8.047h1.23l3.2,5.334,3.139-5.334h1.23l.011,8.047Z",
    transform: "translate(-685.467 -128.345)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M1000.383,176.783a2.652,2.652,0,0,1,1.19.989,3.021,3.021,0,0,1,0,3.052,2.636,2.636,0,0,1-1.19.994,4.458,4.458,0,0,1-1.822.345h-1.817v2.322H995.25v-8.047h3.311a4.458,4.458,0,0,1,1.822.345m-.408,3.7a1.639,1.639,0,0,0,0-2.368,2.3,2.3,0,0,0-1.483-.414h-1.748v3.2h1.748a2.3,2.3,0,0,0,1.483-.414",
    transform: "translate(-723.968 -128.345)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M1038.806,182.623h-4.023l-.793,1.863h-1.541l3.621-8.047h1.471l3.633,8.047h-1.564Zm-.495-1.172-1.517-3.518-1.506,3.518Z",
    transform: "translate(-751.028 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M1088.017,176.439v8.047h-1.23l-4.437-5.449v5.449h-1.483v-8.047h1.23l4.437,5.449v-5.449Z",
    transform: "translate(-786.248 -128.346)",
    fill: "#1f2021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M1127.992,181.647v2.839H1126.5V181.67l-3.161-5.23h1.6l2.357,3.92,2.38-3.92h1.471Z",
    transform: "translate(-817.141 -128.346)",
    fill: "#1f2021"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71b73c37ff6c7df0e3de0dc66ef463c6.svg";
export { ForwardRef as ReactComponent };